import {AnalyticsBrowser} from '@segment/analytics-next'

import {useStore} from 'shared/stores/store'
import {analyticsMethods, cdnURL, integrations, middleware} from 'shared/utils/segment.js'
import {logEvent} from 'shared/utils/eds'
import {init as initAppCues} from 'shared/utils/appcues'

let segment

if (import.meta.env.PROD && import.meta.env.VUE_APP_SEGMENT_WRITE_KEY) {
	segment = new AnalyticsBrowser()
	// NOTE: if we asked users for consent, we'd only call `analytics.load()` if they give it.
	segment.load({writeKey: import.meta.env.VUE_APP_SEGMENT_WRITE_KEY, cdnURL}, {integrations})
	segment.addSourceMiddleware(middleware)
}

if (import.meta.env.PROD && import.meta.env.VUE_APP_TARGET === 'web' && import.meta.env.VUE_APP_APPCUES_ID) {
	// Don't enable AppCues in the Chrome Extension because externally loaded scripts are not allowed.
	initAppCues()
}

const analytics = {}
analyticsMethods.forEach(key => {
	analytics[key] = (...args) => {
		// eslint-disable-next-line no-console
		if (import.meta.env.MODE !== 'production') console.info(`analytics.${key}`, ...args)

		// Log event to Segment
		segment?.[key](...args)

		// Log event to EDS
		const store = useStore()
		const [name, ...payload] = args
		const eventName = `${key} - ${name}`
		const user = {
			beb_user_id: store.user?.id || '',
			browserstack_user_id: store.user?.browserstackUserId || '',
			browserstack_group_id: store.workspace?.browserstackId || '',
		}
		logEvent(eventName, user, ...payload)

		// Log event to AppCues
		window.Appcues?.[key](...args)
	}
})

export default analytics
